import { useEffect, useState } from 'react';
import axios from 'axios';
import '../home/styles.scss';
import 'react-loading-skeleton/dist/skeleton.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


import { Fade } from "react-awesome-reveal";
import { HomeBanner } from '../../components/home/Banner';
import { CaseResultsSection } from '../../components/home/CaseResultsSection';
import { PracticeAreasSection } from '../../components/home/PracticeAreasSection';
import { AttorneysSection } from '../../components/home/AttorneysSection';
import PageLoader from '../../components/global/loader/PageLoader';
import { WhyChooseUsSection } from '../../components/home/WhyChooseUsSection';
import { StepSection } from '../../components/home/StepSection';

const Home = () => {
    const [fields, setFields] = useState([]);
    const [isFetchingPageData, setIsFetchingPageData] = useState(true);
    const [pageContent, setPageContent] = useState(null);
    useEffect(() => {
        document.body.classList.add('home');
        fetchHomeData();
        if (document.querySelector('#wp-admin-bar-edit a')) {
            document.querySelector('#wp-admin-bar-edit a').innerText = `Edit Page`;
            document.querySelector('#wp-admin-bar-edit a').href = `/wp-admin/post.php?post=8&action=edit`;
        }

        document.title = "Top NYC Personal Injury Lawyers - Free Consultation - Joseph T. Mullen";
        return () => {
            document.body.classList.remove('home');
        }
    }, []);



    const fetchHomeData = async () => {
        setIsFetchingPageData(true);
        try {
            const { data } = await axios.get(`/wp-admin/admin-ajax.php?action=get_pages_by_page_name&page_name=home`);
            setFields(data?.fields ?? []);
            setPageContent(data?.page_content ?? null);
            if (data?.yoast_title) {
                 document.title = data?.yoast_title;
            }
        } catch (err) {
            console.log(err);
        } finally {
            setIsFetchingPageData(false);
        }
    }

    useEffect(() => {
        if (isFetchingPageData) {
            document.body.classList.add('is-page-loading');
        } else {
            document.body.classList.remove('is-page-loading');
        }
    }, [isFetchingPageData]);



    return <Fade delay={1}>
        <main id="main" className="home">
            {!isFetchingPageData && <>
                <HomeBanner fields={fields} />
                <CaseResultsSection fields={fields} />
                <AttorneysSection fields={fields} />
                <PracticeAreasSection fields={fields} />
                <WhyChooseUsSection fields={fields} />
                <StepSection fields={fields} />
                <section className='additional-section'>
                    <img width={1920} height={1100} src={fields.handshake_background} />
                </section>
                {pageContent && <section id="default-page-content">
                    <div className='container'>
                        <article  dangerouslySetInnerHTML={{ __html: pageContent }}></article>
                    </div>
                </section>}
            </>}

            {isFetchingPageData && <>
                <PageLoader />
            </>}
        </main>
    </Fade>
}

export default Home;